import { Button } from '@cian/button-component';
import { RadioGroupField, CheckboxField } from '@cian/components';
import * as React from 'react';

import { AsyncActionStatus, TAsyncActionStatus } from '../../../../../store/common';
import { RemoveModalFrame, TRemoveModalFrame } from '../../../../../store/popups/remove';
import { Layout } from '../layout';
import { IconComments } from '../../../../../common/components/icon_comments';
import * as styles from './index.css';
import { trackOfferMovedToArchive, trackArchiveReason, TArchiveReason } from './tracking';
import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export interface IArchiveProps {
  agent: IAgentSchema | null;
  offerId: number;
  isByHomeowner: boolean | null;
  status: TAsyncActionStatus;

  changeActiveFrame(newActiveFrame: TRemoveModalFrame): void;
  onSubmit(): void;
}

interface IArchiveState {
  value: string;
  isErrorMessageVisible: boolean;
  reviewChecked: boolean;
}

interface IOption {
  label: string;
  value: string;
  archiveReason: TArchiveReason;
}

const OPTIONS: IOption[] = [
  {
    label: 'Сделка закрыта',
    value: 'Closed',
    archiveReason: 'deal_close',
  },
  {
    label: 'Неликвидный объект',
    value: 'Nonliquid',
    archiveReason: 'illiquid',
  },
  {
    label: 'Переношу временно, восстановлю позже',
    value: 'Temporary',
    archiveReason: 'temprorily',
  },
  {
    label: 'Другая причина',
    value: 'Other',
    archiveReason: 'other_reason',
  },
];

export class Archive extends React.PureComponent<IArchiveProps, IArchiveState> {
  public state = {
    isErrorMessageVisible: false,
    value: '',
    reviewChecked: false,
  };

  public componentDidMount() {
    trackArchiveReason('Show');
  }

  public render() {
    const { status } = this.props;
    const { reviewChecked, value } = this.state;

    return (
      <Layout
        className={styles['container']}
        isLoading={status === AsyncActionStatus.Loading || status === AsyncActionStatus.Completed}
        title="Почему вы перенесли объявление в архив?"
      >
        <div className={styles['options']}>
          <RadioGroupField value={value} onValueChange={this.handleChangeValue} values={OPTIONS} />
        </div>
        {this.isShowReview(value) && (
          <div className={styles['review-container']}>
            <div>
              <CheckboxField
                label={<b>Запросить отзыв о моей работе у клиента</b>}
                onValueChange={this.handleReviewChecked}
                value={reviewChecked}
              />
              <div className={styles['description']}>
                Агенты с отзывами вызывают больше доверия и привлекают больше клиентов
              </div>
            </div>
            <div className={styles['icon-group-block']}>
              <IconComments />
            </div>
          </div>
        )}
        <footer>
          <Button onClick={this.submit}>Отправить</Button>
          {this.state.isErrorMessageVisible && (
            <span className={styles['error']}>Укажите причину переноса в архив</span>
          )}
          {status === AsyncActionStatus.Failed && <span className={styles['error']}>Ошибка сервера</span>}
        </footer>
      </Layout>
    );
  }

  private handleChangeValue = (value: string) => {
    this.setState(prevState => ({
      isErrorMessageVisible: false,
      value,
      reviewChecked: this.isShowReview(value) ? prevState.reviewChecked : false,
    }));
  };

  private handleReviewChecked = (reviewChecked: boolean) => {
    this.setState({
      reviewChecked,
    });
  };

  private isSpecialist = () => {
    return this.props.agent && this.props.agent.accountType === 'specialist';
  };

  private isPublished = () => {
    return this.props.agent && this.props.agent.status === 'published';
  };

  private isShowReview = (value: string) => {
    return (
      !this.props.isByHomeowner &&
      this.isSpecialist() &&
      this.isPublished() &&
      ['Closed', 'Other'].indexOf(value) !== -1
    );
  };

  private submit = () => {
    const { value, reviewChecked } = this.state;

    if (!value) {
      this.setState({
        isErrorMessageVisible: true,
      });

      return;
    }

    const option = OPTIONS.find(option => option.value === value);

    trackOfferMovedToArchive(this.props.offerId, this.state.value);
    if (option) {
      trackArchiveReason('Send', option.archiveReason);
    }

    if (this.isShowReview(value) && reviewChecked) {
      this.props.changeActiveFrame(RemoveModalFrame.RequestReview);

      return;
    }

    this.props.onSubmit();
  };
}
